module.exports = __webpack_public_path__ + "img/NewsTestImg.04a20881.png";